import client from './client';

export const getLeaveHistory = (userId) => client.get(`/leave/${userId}`).then((r) => r.data);
export const adjustLeave = (userId, amount, note) => client.post(`/leave/${userId}/adjust`, { amount, note }).then((r) => r.data);
